import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  setAuthorization,
  getLoggedinUser
} from "../helpers/api_helper";

const PortalAuth = ({ children }) => {

  const location = useLocation();

  const user = getLoggedinUser();
  const token = user?.token;

  useEffect(() => {

    if (token) {
      setAuthorization(token);
    }

  }, [token]);

  if (!token) {

    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname
        }}
      />
    );
  }

  return children;
};

export default PortalAuth;